/**
 * Check if a string contains emojis
 * Source: https://dev.to/melvin2016/how-to-check-if-a-string-contains-emojis-in-javascript-31pe
 * @param text The text to check for emojis
 * @return Whether the string contains emojis
 */
export const containsEmojis = (text: string): boolean =>
  /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/gi.test(
    text,
  );

/**
 * Strip HTML tags from a string. Converts paragraph boundaries to newlines.
 * @param html The HTML string to strip
 * @return The plain text content
 */
export function stripHtmlTags(html: string): string {
  return html
    .replace(/<\/p>\s*<p[^>]*>/g, '\n')
    .replace(/<[^>]*>/g, '')
    .trim();
}

// Regex to identify any hashtags with #xx format, then removing any duplicate hashtags
// Example: "some text#one#two #three some text" will be counted as 3 hashtags.
export const extractHashtags = (text: string): string[] => {
  const regex = /#([a-zA-Z\d_]+)/g;

  const matches: string[] = [];
  let match: RegExpExecArray | null;

  while ((match = regex.exec(text))) {
    matches.push(match[1]);
  }
  return [...new Set(matches)];
};

// Extract Twitter @mentions from text. Returns the list of usernames in the
// order they appear (no deduplication), matching the regex used by the
// Twitter post editor so caller-side counts (e.g. maxMentionsPerTweet) stay
// aligned. The regex is Twitter-specific (excludes parens, ignores email
// `local@host` patterns) — don't reuse for IG/LinkedIn mention parsing.
export const extractTwitterMentions = (text: string | null | undefined): string[] => {
  const regex = /(^|[^(@\w)]@*)@(\w+)((?=[^\w@])|$)/g;
  return [...(text ?? '').matchAll(regex)].map((match) => match[2]);
};
